import { NavLink } from "react-router-dom";
import "./FocusFallSlide.css";

const desktopImage = "https://firebasestorage.googleapis.com/v0/b/sale-ford-ba315.appspot.com/o/landing-images%2Fdesktop%2F1440%D1%85516.jpg?alt=media&token=6e91eb2e-f4b7-4b6c-8880-e056384a2cc1";
const mobileImage = "https://firebasestorage.googleapis.com/v0/b/sale-ford-ba315.appspot.com/o/landing-images%2Fmobile%2F768%D1%85960.jpg?alt=media&token=e63d6a90-0f0d-47b6-a4b1-c1bda74ac22d";

export default function FocusFallSlide({ active }) {
  return (
    <section className="focus-fall-slide" aria-label="Ford Focus — последни бройки" aria-hidden={!active} data-active={active}>
      <picture className="focus-fall-slide__image">
        <source media="(max-width: 1023px)" srcSet={mobileImage} />
        <img src={desktopImage} alt="Ford Focus в нощния град" />
      </picture>
      <div className="focus-fall-slide__shade" />
      <div className="focus-fall-slide__content">
        <h2>FORD FOCUS</h2>
        <p className="focus-fall-slide__headline">Последни бройки<br />със СУПЕР условия</p>
        <p className="focus-fall-slide__offer">Сега с първоначален разход<br /><span>от <strong>1 899 €<sup>*</sup></strong></span></p>
        <NavLink to="/landing/focus-promo-fall" className="focus-fall-slide__cta" tabIndex={active ? 0 : -1}>Научете повече</NavLink>
      </div>
    </section>
  );
}
